import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchActivePopups } from "../actions/popupActions";
import { useImage } from "../contexts/ImageContext";
import "../styles/Popup.css";

const Popup = () => {
  const dispatch = useDispatch();
  const { popups, loading } = useSelector((state) => state.popups);
  const { getImageUrl } = useImage();
  const [selectedPopup, setSelectedPopup] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    dispatch(fetchActivePopups());
  }, [dispatch]);

  useEffect(() => {
    if (popups && popups.length > 0) {
      // Randomly select a popup
      const randomIndex = Math.floor(Math.random() * popups.length);
      setSelectedPopup(popups[randomIndex]);
      setIsVisible(true);
    }
  }, [popups]);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleCallToAction = () => {
    if (selectedPopup && selectedPopup.link) {
      window.location.href = selectedPopup.link;
    }
  };

  if (!isVisible || !selectedPopup || loading) {
    return null;
  }

  const showButton = selectedPopup.link && selectedPopup.call_to_action_label;

  return (
    <div className="popup-overlay" onClick={handleOverlayClick}>
      <div className="popup-container">
        <button className="popup-close" onClick={handleClose}>
          ×
        </button>
        <div className="popup-content">
          <img
            src={getImageUrl(selectedPopup.image)}
            alt="Popup"
            className="popup-image"
          />
          {showButton && (
            <button className="popup-cta-button" onClick={handleCallToAction}>
              {selectedPopup.call_to_action_label}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Popup;
